<div class="card widget-overview-box widget-overview-box-1">
    <div class="flex justify-content-between">
        <div>
            <span class="overview-title">{{title}}</span>
        </div>
        <div>
            <i class="pi pi-info-circle ml-2" *ngIf="toolTipPath" pTooltip="{{toolTipPath | translate}}"></i>
        </div>
    </div>
    <div class="flex justify-content-between">
        <div class="overview-detail flex justify-content-between">
            <div class="overview-badge flex justify-content-center align-items-center" *ngIf="showBadge">
                <i [class]="badgeClass"></i>
                <span>{{badgeText}}</span>
            </div>
            <p class="overview-text line-height-4 text-4xl" *ngIf="overviewText !== ''; else errorBlock">
                <span>{{overviewText}}{{ isPercentage ? '%' : '' }}</span>
            </p>
            <ng-template #errorBlock>
                <div class="col-12 error-block">
                    <p class="error-block-text">No data available</p>
                </div>
            </ng-template>
        </div>
    </div>
    <img *ngIf="showUpDwnImg" src="assets/layout/images/dashboard/rate.svg">
</div>
